export default {
  title: '禮品列表',
  addGift: '新增禮品',
  editGift: '編輯禮品',
  giftName: '禮品名稱',
  giftNo: '禮品編號',
  giftType: '禮品類型',
  giftCategory: '禮品分類',
  virtualGift: '虛擬禮品',
  physicalGift: '實物禮品',
  id: 'ID',
  giftInfo: '禮品資訊',
  giftPrice: '禮品價格',
  giftSpec: '禮品規格',
  detail: '詳情',
  singleSpec: '單規格',
  multiSpec: '多規格',
};
